import {
	giveHomeFeaturedArticlesParams,
	usePostsFeatured,
} from "@gik/api/posts/postsFeatured";
import { ArticlesGridSkeleton } from "@gik/blog/components/ArticlesGrid/ArticlesGridSkeleton";
import { FetchProvider } from "@gik/core/components/DynamicComponent/FetchProvider";
import type WordpressPost from "@gik/core/models/wordpress/WordpressPost";
import type React from "react";
import { GivePageArticlesGrid } from "./GivePageArticlesGrid";

export type GivePageHelpfulArticlesProps = {
	fallbackData?: WordpressPost[];
};

export function GivePageHelpfulArticles({
	fallbackData,
}: GivePageHelpfulArticlesProps): React.ReactElement {
	const title = `Helpful Articles`;

	return (
		<FetchProvider<WordpressPost[]>
			fetch={function useFetch() {
				return usePostsFeatured(giveHomeFeaturedArticlesParams, {
					fallbackData,
				});
			}}
			loadingComponent={() => <ArticlesGridSkeleton title={title} />}
		>
			{({ data }) => <GivePageArticlesGrid title={title} data={data} />}
		</FetchProvider>
	);
}
